import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import {Link} from 'react-router-dom';

class FallThingsGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fallthingsGallerypage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "fallthingsGallery",
      //'order': 'sys.createdAt'
    }).then((entries) => {
      this.setState({ fallthingsGallerypage: entries.items});
    });
  }

  redirectToTarget=()=>{
    this.props.history.push('/fall-fun')
  }


  render() {
    return (
      <>
      <div className="container-fluid text-left">
        <h1>FALL FUN GALLERY</h1>
      </div>
      <div>
        {this.state.fallthingsGallerypage.length === 0 ?
          <div><img src={BlackLoading} alt="Loading..." /></div> :
              <div className="grid">
                  {this.state.fallthingsGallerypage.map((item, num=0) => {
                      num = num + 1
                      return (
                          <div key={num} className="col-md-4 col-12">
                              <input type="checkbox" id={num} />
                              <label htmlFor={num} className="lightbox"><img src={item.fields.fallthingsGalleryPhoto.fields.file.url} alt="sam bridge fall fun photos" /></label>
                              <label htmlFor={num}><img src={item.fields.fallthingsGalleryPhoto.fields.file.url} alt="sam bridge fall fun photos" /></label>
                              {/* <p className="text-center">{item.fields.fallthingsGalleryTitle}</p> */}
                          </div>
                      )
                  })}
            </div>
      }

      </div>
      <div className="container-fluid">
      <p><Link to="#" onClick={this.redirectToTarget}><button className="btn btn-primary">Back to Fall Fun</button></Link></p>
      </div>
    </>
    );
  }
}

export default FallThingsGallery;
